import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { Divider, Modal, Tooltip } from "antd";
import {
  AlertAssignedByIcon,
  AlertDueDateIcon,
  AlertTitleIcon,
  CaseIdIcon,
  CategoryIcon,
  EyeIcon,
  ReminderFieldDetailIcon,
} from "icons";
import { AlertTitle } from "@mui/material";
import { EmployeeIcon } from "icon-components/employeeIcon";
import { ReminderDetail } from "pages/cases-detail/components/case-reminder/reminder-detail";
import { useNavigate } from "react-router-dom";
import { dateTimeFormatted, getFormattedDate } from "utils/helpers";
import { useLanguageTranslator } from "hooks/use-language-translator";

export const SingleNotificationV1 = ({
  reminderData,
  refetchReminderHistory,
  getReminderDetailLoading,
  setOpenPendingReminders,
}) => {
  const [openReminderDetail, setOpenReminderDetail] = useState(false);
  const navigate = useNavigate();
  const { translator } = useLanguageTranslator();
  const pendingReminderTrans = translator("pendingReminders");

  const {
    title,
    dueDate,
    assignedDate,
    assignedBy,
    subject,
    caseId,
    category,
  } = reminderData || {};

  const data = [
    {
      label: pendingReminderTrans.category,
      value: translator(`caseDetail.form.${category}`),
      icon: ReminderFieldDetailIcon,
    },
    {
      label: pendingReminderTrans.subject,
      value: subject,
      icon: AlertTitleIcon,
    },
    {
      label: pendingReminderTrans.assignedBy,
      value: assignedBy,
      icon: AlertAssignedByIcon,
    },
    // {
    //   label: "Date Assigned",
    //   value: getFormattedDate(assignedDate),
    //   icon: AlertDueDateIcon,
    // },
    {
      label: pendingReminderTrans.dueDate,
      value: getFormattedDate(dueDate),
      icon: AlertDueDateIcon,
    },
  ];

  function closeReminderDetail() {
    setOpenPendingReminders(true);
    setOpenReminderDetail(false);
  }

  const dataForDetail = {
    ...reminderData,
    assigneeName: reminderData?.assigneeName,
    createdAt: reminderData?.assignedDate,
    assignedTo: reminderData?.assignedBy,
  };

  function handleClickSeeCategory({ caseId, category }) {
    navigate(`/cases/${caseId}`);
  }

  const dueDateItem = data[data?.length - 1];
  return (
    <>
      <div className={styles.singleNotification}>
        <div className={styles.cardHeader}>
          <div className={styles.idAndIcon}>
            <div className={styles.icon}>
              <CaseIdIcon />
            </div>
            <div className={styles.caseId}>
              {pendingReminderTrans.caseId}: <span>{caseId}</span>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "3px",
            }}
          >
            <div className={styles.dueIconAndLabel}>
              <dueDateItem.icon />
              {dueDateItem.label}:
            </div>
            <div className={styles.dueValue}>{dueDateItem.value}</div>
          </div>
        </div>
        <Divider style={{ margin: "0" }} />
        <div className={styles.rows}>
          {data.slice(0, 3)?.map((item) => (
            <div className={styles.singleRow} key={item.label}>
              <div className={styles.iconAndLabel}>
                <item.icon />
                {item.label}:
              </div>
              <div className={styles.value}>{item.value}</div>
            </div>
          ))}
        </div>
        <div className={styles.actionIcons}>
          <Tooltip title={`${translator("caseDetailLabel")}: ${caseId} `}>
            <div
              className={styles.iconContainer}
              onClick={() =>
                handleClickSeeCategory({
                  caseId,
                  category: reminderData?.category,
                })
              }
            >
              <ReminderFieldDetailIcon />
            </div>
          </Tooltip>
          <Tooltip title={translator("caseDetail.reminder.reminderDetail")}>
            <div
              className={styles.iconContainer}
              onClick={(e) => {
                e.stopPropagation();
                setOpenReminderDetail(true);
              }}
            >
              <EyeIcon height={15} width={15} />
            </div>
          </Tooltip>
        </div>
      </div>
      <Modal
        destroyOnClose
        // title="Set Reminder"
        maskClosable={false}
        open={openReminderDetail}
        onCancel={closeReminderDetail}
        footer={null}
        centered
        width="98dvw"
        styles={{
          content: {
            backgroundColor: "#F5F6F8",
            height: "98dvh",
          },
          header: { backgroundColor: "#F5F6F8" }, // turns the Modal red
        }}
      >
        <ReminderDetail
          reminderData={dataForDetail}
          closeReminderDetail={closeReminderDetail}
          refetchReminderHistory={refetchReminderHistory}
          loading={getReminderDetailLoading}
        />
      </Modal>
    </>
  );
};
